import { UserGeneratedConfigService } from 'app/config/user_generated_config.service';
import {
    FrontEndConfigFormField,
    FrontEndConfigFormModel,
} from 'app/overview/config/configuration_tab/general/frontend_config/FrontEndConfigFormModel';
import { BooleanFormFieldModel } from 'app/overview/config/configuration_tab/general/frontend_config/BooleanFormFieldModel';
import { TerrainProviderListFormModel } from 'app/overview/config/configuration_tab/general/frontend_config/terrain/TerrainProviderListFormModel';
import { ImageryProviderListFormModel } from 'app/overview/config/configuration_tab/general/frontend_config/imagery/ImageryProviderListFormModel';
import { MapLayerOptionsHelper } from 'app/overview/config/data/MapLayerOptionsHelper';
import { NumberFormFieldModel } from './configuration_tab/general/frontend_config/NumberFormFieldModel';
import { FeatureLayerProviderListFormModel } from 'app/overview/config/configuration_tab/general/frontend_config/featureLayer/FeatureLayerProviderListFormModel';
import { ColorFormFieldModel } from 'app/overview/config/configuration_tab/general/frontend_config/ColorFormFieldModel';

/**
 * Builds up and holds the form.
 */
export class FrontEndConfigFormService {
    /**
     * The singular form model used in the application!
     */
    private _frontEndConfigFormModel: FrontEndConfigFormModel;

    constructor(userGeneratedConfigService: UserGeneratedConfigService) {
        this._frontEndConfigFormModel = new FrontEndConfigFormModel(userGeneratedConfigService);
    }

    /**
     * Once the imagery map options have been collected from the API, give it to this service.
     *
     * This will allow the service to continue with its initialisation
     *
     * @param {MapLayerOptionsHelper} imagMapOptionsHelper
     */
    setImageryMapOptionsHelper(imagMapOptionsHelper: MapLayerOptionsHelper): void {
        // Added form fields will appear in the order that they are added
        new ImageryProviderListFormModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.IMAGERY_LAYERS,
            {
                mapOptionsHelper: imagMapOptionsHelper,
            },
        );
        new FeatureLayerProviderListFormModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.FEATURE_LAYERS,
        );
        new TerrainProviderListFormModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.TERRAIN_PROVIDERS,
        );
        new BooleanFormFieldModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.REMOVE_BASE_BING_LAYER,
        );
        new NumberFormFieldModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.LIVE_LATENCY,
        );
        new NumberFormFieldModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.HEATMAP_LIMIT,
        );
        new NumberFormFieldModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.HEATMAP_CHUNK_SIZE,
        );
        new BooleanFormFieldModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.CONNECTION_OUTLINE,
        );
        new BooleanFormFieldModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.THROUGHPUT_AS_BITS,
        );
        new ColorFormFieldModel(
            this._frontEndConfigFormModel,
            FrontEndConfigFormField.BASE_GLOBE_COLOR,
        );
    }

    get frontEndConfigFormModel(): FrontEndConfigFormModel {
        return this._frontEndConfigFormModel;
    }
}
